export const LOCATION = {
  W: 'W',
  P: 'P',
  C: 'C',
  S: 'S'
} as const;

export type Location = (typeof LOCATION)[keyof typeof LOCATION];

/** Legacy RITA's own names for the location types — resolved through `t()` at render. */
export const LOCATION_TITLE_KEYS = {
  W: 'locationType.W',
  P: 'locationType.P',
  C: 'locationType.C',
  S: 'locationType.S'
} as const;

export type LocationTypeFilter = Record<Location, boolean>;

/**
 * Types the counts row shows. `S` (Site Definition) exists in the data model but no
 * layer draws it — neither here nor in legacy — so counting it printed a permanent zero.
 */
export const COUNTED_LOCATION_TYPES = [LOCATION.W, LOCATION.P, LOCATION.C] as const;

export type CountedLocation = (typeof COUNTED_LOCATION_TYPES)[number];
export type FilteredLocationCounts = Record<CountedLocation, number>;
